var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25485 0.196478H0.243333C0.462163 -0.0329533 0.83072 -0.032953 1.04955 0.185006L7.54536 6.65496L14.0412 0.173535H14.0297C14.2485 -0.0558964 14.617 -0.0558961 14.8359 0.162063C15.0547 0.380023 15.0547 0.747112 14.8359 0.965072L7.92544 7.848V7.83653C7.69509 8.05449 7.32653 8.05449 7.1077 7.83653C7.09618 7.82506 7.09618 7.82506 7.09618 7.82506L0.185746 0.942129L0.174228 0.930657C-0.0561196 0.701226 -0.0561197 0.334137 0.162711 0.116177C0.162711 0.104706 0.162711 0.104705 0.162711 0.104705L0.25485 0.196478Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallwhite);
export default __webpack_public_path__ + "static/media/smallwhite.cc7a98f3ab6432f0806d589ff0e707f9.svg";
export { ForwardRef as ReactComponent };